import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import avatar from '../assets/images/avatar.jpg';
import '../assets/styles/Main.scss';

function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src={avatar} alt="Avatar" />
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://github.com/mario2r" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/mario-romero-rodriguez/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
          <h1>Mario Romero Rodriguez</h1>
          <p>Staff iOS Engineer | Swift • SwiftUI • UIKit | Performance & Scalable</p>

          <div className="mobile_social_icons">
            <a href="https://github.com/mario2r" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/mario-romero-rodriguez/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;
